<template>
  <app-layout :account-global-menu="accountGlobalMenu">
    <template #main-content>
      <main id="content" class="l-main p-account">
        <div class="l-main__inner">
          <div class="c-page-header">
            <h1 class="c-page-header-title">バージョン情報/利用期限</h1>
            <button-return @click="goBack" name="S6-2-version-back-btn">戻る</button-return>
          </div>
          <section>
            <div class="c-parts-box">
              <div class="c-parts-box__inner">
                <section class="p-account-item">
                  <h2 class="p-account-item__title">バージョン情報</h2>
                  <p class="p-account-item__text">アプリケーションのバージョン：{{version}}</p>
                </section>
                <section class="p-account-item">
                  <h2 class="p-account-item__title">利用期限</h2>
                  <table class="c-table-account">
                    <thead>
                      <tr>
                        <th>教科</th>
                        <th>期限</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="license in accountStore.licenseExpiration">
                        <td>{{license.subject_name}} <span v-if="license.subject_name !== license.subject_field_name">({{license.subject_field_name}})</span></td>
                        <td>{{convertLocalString(license.expiration)}}まで</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted} from "vue"
  import {useRouter} from "vue-router"
  import { useAccountStore } from '@/store/student/account_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';

  const accountStore = useAccountStore()
  const router = useRouter()
  const accountGlobalMenu = ref(true)
  const version = ref("")

  onMounted(() => {
    document.title = "バージョン情報/利用期限"
    useGlobalNavigationStore().saveSelectedMenu("acVersion")
    // save app_version information
    const element:any = window.document.getElementById("app_version");
    version.value = element.innerHTML
    accountStore.fetchLicenseExpiration()
  })
  function goBack(){
    router.go(-1)
  }
  function convertLocalString(date: string) {
    let dt = new Date(date);
    let y = dt.getFullYear();
    let m = ('00' + (dt.getMonth() +1 )).slice(-2);
    let d = ("00" + dt.getDate()).slice(-2);
    return y + '年' + m + '月' + d + '日';
  }
</script>
